
import { defineComponent } from "vue";
import { useContext, SandpackStateContext } from "codesandbox-sandpack-vue3";
import { mapState, mapMutations } from "vuex";

export default defineComponent({
  name: "SandpackNavigation",
  props: {
    codeMap: Object,
  },
  components: {},
  emits: ["getLoading"],
  data() {
    return {
      sandpackApp: null,
      stopListening: null,
      loadingConfig: {
        loading: false,
        text: "运行",
      },
    };
  },
  mounted() {
    this.start();
  },
  unmounted() {
    if (this.stopListening) {
      const stopListening: any = this.stopListening;
      stopListening();
    }
  },
  computed: {
    ...mapState(["sandpackApp"]),
  },
  methods: {
    ...mapMutations(["setSandpackApp"]),
    refreshHandle() {
      if (this.sandpackApp) {
        const sandpackApp: any = this.sandpackApp;
        sandpackApp.dispatch({ type: "refresh" });
      }
    },
    start() {
      const sandpackApp: any = useContext(SandpackStateContext, undefined);
      this.sandpackApp = sandpackApp;
      const stopListening = sandpackApp.listen((msg: any) => {
        if (msg.type === "start") {
          this.$emit("getLoading", true);
          this.loadingConfig = {
            loading: true,
            text: "运行中",
          };
        } else if (msg.type === "done") {
          this.$emit("getLoading", false);
          this.loadingConfig = {
            loading: false,
            text: "运行",
          };
        }
      });
      this.stopListening = stopListening;
      this.setSandpackApp(sandpackApp);
    },
  },
});
